import axiosInstance from 'axios';
import { stringify } from '../polyfills';
var transformRequest = function (data) {
    if (typeof data === 'string') {
        return data;
    }
    return stringify(data);
};
export var axios = axiosInstance.create({
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
    },
    transformRequest: [transformRequest], // fix confict with prototype.js http://prototypejs.org/
});
